<template>
  <div class="documents-list">
    <div class="m-b-15">
      <ul class="files-list">
        <li class="file text-left" v-for="file in filesList" :key="file.documentId">
          <div class="text">
            <div class="file-name" :title="file.name | documentNameByCategoryAndTitle(file.type, file.title)">
              {{ file.name | documentNameByCategoryAndTitle(file.type, file.title) }}
            </div>
            <div class="file-description">
              <div class="file-size" v-if="'documentSize' in file && file.documentSize !== null">{{ file.documentSize | fileSize }} -</div>
              <time :datetime="file.uploadedDate">{{ file.uploadedDate | dateFormat }}</time>
            </div>
          </div>
          <Spinner v-if="deletingDocIds.includes(file.documentId)" />
          <a v-else class="delete-btn" role="button" @click.prevent="deleteHandler(file.documentId)"><i class="icon material-icons">close</i></a>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import Spinner from '@/components/Spinner.vue'
import { deleteDocument } from '@/api/document'
import { getDocumentNameByCategoryAndTitle } from '@/utils/utils'

export default {
  name: 'DocumentsList',
  components: {
    Spinner
  },
  props: {
    filesList: {
      type: Array
    }
  },
  data() {
    return {
      deletingDocIds: []
    }
  },
  methods: {
    async deleteHandler(documentId) {
      try {
        this.deletingDocIds.push(documentId)
        await deleteDocument(documentId)
        this.$emit('change')
      } catch (e) {
        console.error(e)
      } finally {
        this.deletingDocIds = this.deletingDocIds.filter(id => id !== documentId)
      }
    }
  },
  filters: {
    documentNameByCategoryAndTitle() {
      return getDocumentNameByCategoryAndTitle(...arguments)
    }
  }
}
</script>

<style lang="scss" scoped>
.file-type-title {
  font-weight: 500;
}
</style>
